import DataRoomStorage from './DataRoomStorage.component';

export default DataRoomStorage;